import React from 'react'
import { node } from 'prop-types'
import * as S from './style'

const BaseCard = ( { children } ) => {
  return (
    <S.Card>
      { children }
    </S.Card>
  )
}

BaseCard.propTypes = {
  'children': node.isRequired
}

export default BaseCard
